export const REDIS_OPTIONS = {
	URL: `redis://${process.env.REDIS_HOST ?? 'localhost'}:${process.env.REDIS_PORT ?? '6379'}`,
	HOST: process.env.REDIS_HOST ?? 'localhost',
	PORT: Number(process.env.REDIS_PORT ?? '6379'),
	DB: Number(process.env.REDIS_DB ?? '0'),
}
